import React from "react";
import PostCard from "./post-card";

export default function RelatedPostCards({ className, posts = [] }) {
  if (!posts?.every((post) => post)) {
    throw new Error("Invalid related post name!");
  }

  return (
    <div className={className}>
      <h2 className="uppercase">You also may like</h2>
      <div className="border-primary border-b w-12 h-1 mb-8 mt-2" />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {posts.map((post) => (
          <PostCard className="h-auto" key={post.id} post={post} />
        ))}
      </div>
    </div>
  );
}
